import { APIcaller } from '@src/commons/utils/APICaller';
import { handleLogout } from '@src/commons/utils/hooks/authentication';
import { Navigate, Outlet } from 'react-router-dom';
import { useEffect } from 'react';

const Secure = () => {
  useEffect(() => {
    (async () => {
      try {
        await APIcaller.apiGet('/me');
      } catch {
        handleLogout();
      }
    })();
  }, []);

  const localStorageToken = localStorage.getItem('accessToken');

  return localStorageToken ? <Outlet /> : <Navigate to="/login" replace />;
};

export default Secure;
